var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { getInitials, getName, hasConnection, } from "../../../redux/contact/contact.utils";
import images from "../../assets";
import ListItem from "../ListItem";
import ListItemSelect from "../ListItemSelect";
import * as S from "./ContactListItem.styles";
var ContactListItem = /** @class */ (function (_super) {
    __extends(ContactListItem, _super);
    function ContactListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Render
    ContactListItem.prototype.render = function () {
        var _a = this.props, _b = _a.showAsSelector, showAsSelector = _b === void 0 ? true : _b, _c = _a.selected, selected = _c === void 0 ? false : _c, contact = _a.contact, account = _a.account, rest = __rest(_a, ["showAsSelector", "selected", "contact", "account"]);
        var person = contact || account;
        if (!person) {
            return null;
        }
        var pictureUrl = contact ? contact.pictureUrl : undefined;
        var showNoConnectionBadge = contact && !hasConnection(contact);
        var noConnectionBadge = _jsx(S.BadgeStyled, { icon: images.ICO_CONNECTION_NO });
        var baseProps = {
            title: getName(person) || " ",
            isCompany: !!person.company,
            iconLeft: pictureUrl ? { uri: pictureUrl } : undefined,
            iconLeftIsRounded: true,
            iconLeftText: getInitials(person) || " ",
            extraTitleComponent: showNoConnectionBadge
                ? noConnectionBadge
                : undefined,
        };
        return (_jsx(S.Wrap, { children: showAsSelector ? (_jsx(ListItemSelect, __assign({ selected: selected }, baseProps, rest))) : (_jsx(ListItem, __assign({ showDisclosureIcon: true }, baseProps, rest))) }));
    };
    return ContactListItem;
}(React.PureComponent));
// eslint-disable-next-line import/no-default-export
export default ContactListItem;
